import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyDown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeyDown)
    this.boundHandleKeyDown = null
  }

  openSearchWithTab(tabType = null) {
    // Open the search modal using the modal frame
    const frame = document.querySelector('turbo-frame#modal')
    if (frame) {
      const searchLink = document.querySelector('#search-shortcut')
      if (searchLink) {
        // Get the base URL from the search link
        let url = searchLink.href

        // Parse the current URL to check if we're inside a company
        const currentUrl = new URL(window.location.href)
        const companyMatch = currentUrl.pathname.match(/\/companies\/(\d+)/)
        const companyId = companyMatch ? companyMatch[1] : null

        // Create a URL object to properly handle parameters
        const searchUrl = new URL(url)

        // Add the view parameter if a tab type is specified
        if (tabType) {
          searchUrl.searchParams.set('view', tabType)
        }

        // Add the company parameter if we're inside a company
        if (companyId) {
          searchUrl.searchParams.set('company', companyId)
        }

        // Set the frame source to the complete URL
        frame.src = searchUrl.toString()
      }

      // Focus the input after a short delay to allow the modal to open
      setTimeout(() => {
        const searchInput = document.querySelector('#mainSearchInput')
        if (searchInput) searchInput.focus()
      }, 100)
    }
  }

  handleKeyDown(event) {
    // Skip if user is typing in an input or textarea
    if (this.isUserTyping()) return

    // Open search modal
    if (event.key === '/' && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey) {
      event.preventDefault()
      this.openSearchWithTab()
    }



    // Open search modal with specific tabs
    if (!event.ctrlKey && !event.metaKey && !event.altKey) {
      switch (event.key) {
        case 'p':
        case 'P':
          event.preventDefault()
          this.openSearchWithTab('Password')
          break
        case 'c':
        case 'C':
          event.preventDefault()
          this.openSearchWithTab('Company')
          break
        case 'a':
        case 'A':
          event.preventDefault()
          this.openSearchWithTab('Asset')
          break
        case 'k':
        case 'K':
          event.preventDefault()
          this.openSearchWithTab('Article')
          break
        case 'w':
        case 'W':
          event.preventDefault()
          this.openSearchWithTab('Website')
          break
        case 'o':
        case 'O':
          event.preventDefault()
          this.openSearchWithTab('Process')
          break
      }
    }


    // if CTRL + K, open keyboard shortcuts menu
    if (event.key === '/' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      if (document.querySelector('#keyboard-shortcuts-shortcut')) {
        document.querySelector('#keyboard-shortcuts-shortcut').click()
      }
      return;
    }

    if ((event.key === 'h' || event.key === 'H') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#ai-shortcut')) {
        document.querySelector('#ai-shortcut').click()
      }
      return;
    }

    if ((event.key === 'm' || event.key === 'M') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#add-comment-shortcut')) {
        document.querySelector('#add-comment-shortcut').click()
      }
      return;
    }

    if ((event.key === 'e' || event.key === 'E') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#edit-shortcut')) {
        document.querySelector('#edit-shortcut').click()
      }
      return;
    }

    if ((event.key === 'f' || event.key === 'F') && event.shiftKey && !event.altKey && !event.ctrlKey) {
      event.preventDefault()
      if (document.querySelector('#favorite-shortcut')) {
        document.querySelector('#favorite-shortcut').click()
      }
      return;
    }

    if (event.key === '[' && !event.ctrlKey && !event.metaKey && !event.altKey) {
      event.preventDefault()
      const toggleButtons = Array.from(document.querySelectorAll('.toggle-pane-button'));
      const visibleButton = toggleButtons.find(button => {
        const style = window.getComputedStyle(button);
        return style.display !== 'none';
      });

      if (visibleButton) {
        visibleButton.click();
      }
      return;
    }

    if (event.key === ']' && !event.ctrlKey && !event.metaKey && !event.altKey) {
      event.preventDefault()
      const visibleButton = document.querySelector('.cpanel__switch')

      if (visibleButton) {
        visibleButton.click();
      }
      return;
    }
  }

  isUserTyping() {
    const activeElement = document.activeElement;
    const tagName = activeElement.tagName;
    return ['INPUT', 'TEXTAREA', 'SELECT'].includes(tagName);
  }
}
